import {
	type FetchCurrenciesParams,
	type FetchCurrencyComputedConversionRatesParams,
	walletApi
} from '@capsicum/common';

export async function fetchCurrencies(params?: FetchCurrenciesParams) {
	return (await walletApi)
		.fetchCurrencies({
			limit: 1000,
			'statuses[]': ['enabled'],
			...params
		})
		.then(res => res.data);
}

export async function fetchConversionRates(params: FetchCurrencyComputedConversionRatesParams) {
	return (await walletApi).fetchCurrencyComputedConversionRates(params).then(res => res.data);
}
